import React from "react";
import {fetchRestaurants, sortRestaurants} from "../reducers/restaurants";
import {setMainPageIndex} from "../reducers/app";
import SeoComponent from "../common/SeoComponent";
import LayoutComponent from "../common/LayoutComponent";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {getByAlias} from '../selectors/common';
import {Link, Redirect, Route, Switch} from "react-router-dom";
import NotFound from "./NotFound";
import IntManager, {t} from "../IntManager";
import Api from "../Api";
import {Power3, TimelineLite, TweenMax} from 'gsap';
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';
import GSAP from 'react-gsap-enhancer';
import $ from "jquery";

function appearAnim({target}) {
    const tl = new TimelineLite();
    const transition = Power3.easeOut;
    const timer = .5;
    const slideNegative = 70;

    return tl.fromTo('.js-slideup', timer, {y: "+=100%"}, {y: "-=100%", ease: transition})
        .fromTo(target.findAll({name: 'meta'}), timer, {y: "+=100%"}, {y: "-=100%", ease: transition}, '-=' + timer)
        .fromTo(target.find({name: 'content'}), timer, {marginTop: 0}, {
            marginTop: '-=' + slideNegative + 'px',
            ease: transition
        }, '-=' + timer);
}

const scrollListener = (e) => {
    const st = $(e.target).scrollTop();
    const transition = Power3.easeOut;
    const verticalLine = $('.vertical-line');
    const caseText = $('.js-case-text');

    if (st > 30) {
        TweenMax.to(verticalLine, .5, {
            autoAlpha: 0,
            y: 20,
            ease: transition
        });
    } else if (st < 30) {
        TweenMax.to(verticalLine, .5, {
            autoAlpha: 1,
            y: 0,
            ease: transition
        });
    }

    if (st <= window.innerHeight && window.matchMedia("(min-width: 480px)").matches) {
        caseText.css({
            transform: 'translateY(' + (st / 3) + 'px)'
        });
        $('.js-scroll-down').css({
            transform: 'translate3d(-50%,' + (st / 3) + 'px,0)'
        });
    }

};

class Restaurant extends SeoComponent {
    static fetchData(store) {
        return store.dispatch(fetchRestaurants());
    }

    constructor(props, context) {
        super(props, context);

        this.onChangePageAnimation = this.onChangePageAnimation.bind(this);

        this.state = {
            redirect: null
        };
    }

    onChangePageAnimation(e, url) {
        e.preventDefault();

        $('html,body').scrollTop(0);
        this.setState({redirect: url});

        // const tl = new TimelineLite({
        //     onComplete: () => {
        //         $('html,body').scrollTop(0);
        //         this.setState({redirect: url});
        //     }
        // });
        //
        // tl.to('.page', .3, {autoAlpha: 0})
        //     .to('.nav', .3, {autoAlpha: 0}, '-=.3');
    }

    componentDidMount() {
        if (this.props.restaurant === null) {
            this.props.fetchRestaurants(this.props.match.params.alias);
        }
        this.addAnimation(appearAnim);
        window.addEventListener('scroll', scrollListener);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', scrollListener);
    }

    backRedirect(t) {
        t.setState({redirect: '/'});
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.restaurant && (prevProps.restaurant !== this.props.restaurant) && this.state.redirect) {
            this.setState({redirect: null});
        }
    }

    render() {
        const redirect = this.state.redirect;
        if (redirect && this.props.match.url !== redirect) {
            return <Redirect push={true} to={redirect}/>;
        }

        let content;
        if (this.props.populated && this.props.restaurant === null) {
            return <Switch>
                <Route component={NotFound}/>
            </Switch>
        } else if (this.props.error) {
            content = <div>Не удалось получить данные с сервера</div>
        } else if (this.props.loading || this.props.restaurant === null) {
            content = <div>Loading</div>
        } else {
            this.setMetaTags(t('main_title') + ' - ' + this.props.restaurant.title);
            content = this.renderContent();
        }

        return <LayoutComponent hideNav routerMatch={this.props.match}>
            {content}
        </LayoutComponent>
    }

    renderNextLink() {
        if (this.props.nextRestaurant) {
            const urlPrev = IntManager.getUrl(`/restaurants/${this.props.prevRestaurant.alias}`);
            const urlNext = IntManager.getUrl(`/restaurants/${this.props.nextRestaurant.alias}`);
            return (
                <div className="section__next-page u-black-background">
                    <Link to={urlPrev} onClick={(e) => this.onChangePageAnimation(e, urlPrev)}
                          className="section__next-page__link u-relative">
                        <div style={{backgroundImage: 'url(' + Api.getImage(this.props.prevRestaurant.image) + ')'}}
                             className="section__next-page__link-bg imgfill u-fit u-pos-tl u-absolute"></div>
                        <span className="section__next-page__link-text u-color--white u-block u-relative ui-light u-bold">
                            {this.props.prevRestaurant.title}
                        </span>
                        <span className="section__next-page__link-arrow u-absolute">
                            <span className="u-block u-absolute u-overflow-h slider-arrow__base">
                                <span className="slider-arrow__circle u-absolute u-pos-tl u-fit u-block u-overflow-h"/>
                            </span>
                            <span className="slider-arrow__inner u-pos-tl u-absolute u-fit u-block">
                                <span className="slider-arrow__icon u-absolute u-overflow-h u-block">
                                    <span className="slider-arrow__bar u-absolute u-inline-block u-white-background"/>
                                    <svg className="slider-arrow__triangle u-absolute u-fill--white u-block u-pos-tl">
                                        <use xlinkHref="/static/media/svg-symbols.svg#triangle-right"/>
                                    </svg>
                                </span>
                            </span>
                        </span>
                    </Link>
                    <Link to={urlNext} onClick={(e) => this.onChangePageAnimation(e, urlNext)}
                          className="section__next-page__link u-relative">
                        <div style={{backgroundImage: 'url(' + Api.getImage(this.props.nextRestaurant.image) + ')'}}
                             className="section__next-page__link-bg imgfill u-fit u-pos-tl u-absolute"></div>
                        <span className="section__next-page__link-text u-color--white u-block u-relative ui-light u-bold">
                            {this.props.nextRestaurant.title}
                        </span>
                        <span className="section__next-page__link-arrow u-absolute">
                            <span className="u-block u-absolute u-overflow-h slider-arrow__base">
                                <span className="slider-arrow__circle u-absolute u-pos-tl u-fit u-block u-overflow-h"/>
                            </span>
                            <span className="slider-arrow__inner u-pos-tl u-absolute u-fit u-block">
                                <span className="slider-arrow__icon u-absolute u-overflow-h u-block">
                                    <span className="slider-arrow__bar u-absolute u-inline-block u-white-background"/>
                                    <svg className="slider-arrow__triangle u-absolute u-fill--white u-block u-pos-tl">
                                        <use xlinkHref="/static/media/svg-symbols.svg#triangle-right"/>
                                    </svg>
                                </span>
                            </span>
                        </span>
                    </Link>
                </div>
            )
        }
    }

    renderImages() {
        const images = [];

        if (this.props.restaurant.gallery && this.props.restaurant.gallery.publishedPhotos) {
            for (let i in this.props.restaurant.gallery.publishedPhotos) {
                if (this.props.restaurant.gallery.publishedPhotos.hasOwnProperty(i)) {
                    const photo = this.props.restaurant.gallery.publishedPhotos[i]['image'];
                    images.push(
                        <React.Fragment key={i}>
                            <div className="section__image"><img className="lazyload" alt="" data-src={Api.getImage(photo)}/>
                            </div>
                            <div className="section__space u-fit-w hide-mobile"></div>
                        </React.Fragment>
                    )
                }
            }
        }

        return <React.Fragment>{images}</React.Fragment>
    }

    renderMenus() {
        const menus = [];

        if (this.props.restaurant.menus) {
            for (let i in this.props.restaurant.menus) {
                if (this.props.restaurant.menus.hasOwnProperty(i)) {
                    const isFoodMenu = this.props.restaurant.menus[i]['type'];
                    menus.push(
                        <React.Fragment key={i}>
                            <li className="u-relative u-overflow-h js-case-text">
                                <a name="meta" href={Api.getImage(this.props.restaurant.menus[i]['file'])}
                                   className="page-hero__btn u-block u-color--white" target="_blank">
                                    {isFoodMenu === '2' ? (
                                        <div className="u-flex u-align-items-c">
                                            <svg className="u-inline-block u-valign-middle icon-external-link u-fill--white" width="16" height="16">
                                                <use xlinkHref="/static/media/svg-symbols.svg#plate"/>
                                            </svg>
                                            <div className="u-relative u-overflow-h">
                                                <span className="page-hero__btn__inner">{t('menu')}</span>
                                                <span className="page-hero__btn__inner-top u-absolute u-pos-tl">
                                                    {t('menu')}
                                                </span>
                                                <span className="page-hero__btn__inner-bottom u-absolute u-pos-tl">
                                                    {t('menu')}
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="u-flex u-align-items-c">
                                            <svg className="u-inline-block u-valign-middle icon-external-link u-fill--white" width="16" height="16">
                                                <use xlinkHref="/static/media/svg-symbols.svg#martini"/>
                                            </svg>
                                            <div className="u-relative u-overflow-h">
                                                <span className="page-hero__btn__inner">{t('drinks')}</span>
                                                <span className="page-hero__btn__inner-top u-absolute u-pos-tl">
                                                    {t('drinks')}
                                                </span>
                                                <span className="page-hero__btn__inner-bottom u-absolute u-pos-tl">
                                                    {t('drinks')}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </a>
                            </li>
                        </React.Fragment>
                    );
                }
            }

            return <React.Fragment>{menus}</React.Fragment>
        }
    }

    renderContent() {

        const pageBackground = {
            backgroundImage: 'url(' + Api.getImage(this.props.restaurant.image) + ')'
        };

        return (
            <div className="page">
                <div className="u-overlay u-fixed u-fit u-pos-tl"></div>
                <div className="page__view u-relative">
                    <div className="page__background" style={pageBackground}></div>
                </div>
                <div className="page__inner u-absolute u-fit u-pos-tl">
                    <div className="page__hero u-relative ui-light u-overflow-h u-fit">
                        <div className="page-hero__screen u-relative u-fit-w">
                            <h2 name="title" className="slide__title u-color--white u-block u-color--white js-case-text" dangerouslySetInnerHTML={{__html: this.props.restaurant.slideTitle}}/>
                            <ul className="page-hero__meta u-fit-w ui-light js-slideup">
                                {this.renderMenus()}
                            </ul>
                        </div>
                        <a href="#case-view"
                           className="page-hero__scroll-down u-color--white u-absolute u-overflow-h js-scroll-down"
                           onClick={(e) => {
                                   const target = $(e.currentTarget.getAttribute('href'));
                                   if (target.length) {
                                       e.preventDefault();
                                       $('html, body').stop().animate({
                                           scrollTop: target.offset().top
                                       }, 500);
                                   }
                        }}>
                            <span name="meta" className="slide-message__wrapper u-block">
                                <span className="slide-message__text u-valign-middle u-inline-block">
                                    {t('scroll')}
                                </span>
                                <span
                                    className="slide-message__icon u-valign-middle u-inline-block u-relative u-overflow-h">
                                    <svg className="slider-message__triangle u-absolute u-fill--white">
                                        <use xlinkHref="/static/media/svg-symbols.svg#triangle-bottom"/>
                                    </svg>
                                    <svg className="slider-message__triangle u-absolute u-fill--white _clone">
                                        <use xlinkHref="/static/media/svg-symbols.svg#triangle-bottom"/>
                                    </svg>
                                    <span className="slider-message__circle u-pos-tl u-absolute u-fit u-block"/>
                                </span>
                            </span>
                        </a>
                    </div>
                </div>
                <div id="case-view" name="content"
                     className="page__content u-fit-w u-relative u-white-background --negative">
                    <div className="section">
                        <div className="section__desc section-desc">
                            <h2 className="section-desc__title u-bold">{t('concept')}</h2>
                            <p className="section-desc__text" dangerouslySetInnerHTML={{__html: this.props.restaurant.description}}></p>
                        </div>
                        {this.renderImages()}
                        {this.renderNextLink()}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    const restaurants = sortRestaurants(state.restaurants.items);
    const restaurant = getByAlias(state.restaurants.items, props.match.params.alias);
    let prevRestaurant = null;
    let nextRestaurant = null;
    let slideIndex = null;

    if (restaurant !== null && restaurants.length > 1) {
        const lastIndex = restaurants.length - 1;
        const index = restaurants.indexOf(restaurant);
        slideIndex = index;

        nextRestaurant = restaurants[index >= lastIndex ? 0 : index + 1];
        prevRestaurant = restaurants[index <= 0 ? lastIndex : index - 1];
    }

    return {
        restaurant,
        prevRestaurant,
        nextRestaurant,
        slideIndex,
        error: state.restaurants.error,
        loading: state.restaurants.loading,
        populated: state.restaurants.populated
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({fetchRestaurants, setMainPageIndex}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(GSAP()(Restaurant));


// WEBPACK FOOTER //
// ./src/js/components/Restaurant.js